import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";

import MDActionConfigurator from "components/MDActionConfigurator";

import { createOrder } from "actions/orderActions";
import { getUserList } from "actions/userActions";
import { getClientList } from "actions/clientActions";
import MDProductPercentageDialog from "components/MDProductPercentageDialog";

function CreateOrderButton({ selectProduct }) {
  const configuratorRef = useRef(null);
  const dispatch = useDispatch();
  const [dynamicProductAmount, setDynamicProductAmount] = useState(0);
  const [selectAdminUser, setSelectAdminUser] = useState([]);
  const [selectClient, setSelectClient] = useState([]);
  const [selectAddons, setSelectAddons] = useState([]);
  const [currentState, setCurrentState] = useState("");
  const [currentData, setCurrentData] = useState({
    _id: "",
    requestedBy: "",
    assignedTo: "",
    product: "",
    service: "",
    supplier: "",
    addons: "",
    computedAmount: 0,
    adminNotes: "",
    status: "",
    responseRequirements: "",
    startDate: "",
    endDate: "",
  });

  const listUsers = useSelector((state) => state.listUsers);
  const { usersList } = listUsers;

  const listClients = useSelector((state) => state.listClients);
  const { clientsList } = listClients;

  useEffect(() => {
    setSelectAddons(
      selectProduct?.addons?.map((item) => ({
        value: item._id,
        name: item.addonName,
        addonAmount: item.addonAmount,
      }))
    );
  }, [dispatch, selectProduct?._id]);

  useEffect(() => {
    if (usersList?.length === 0) {
      dispatch(getUserList());
    }
    setSelectAdminUser(
      usersList?.map((item) => ({
        value: item._id,
        name: item.name,
      }))
    );
  }, [dispatch, usersList?.length]);

  useEffect(() => {
    if (clientsList?.length === 0) {
      dispatch(getClientList());
    }
    setSelectClient(
      clientsList?.map((item) => ({
        value: item._id,
        name: item.name,
      }))
    );
  }, [dispatch, clientsList?.length]);

  const handleToggleBackdrop = (item, state) => {
    setCurrentData(item);
    setCurrentState(state);
    if (configuratorRef.current) {
      configuratorRef.current.handleToggleConfigurator();
    }
  };

  const handleSubmitOrder = (e) => {
    if (e?.addons?.length !== 0) {
      const finalAddons = e?.addons?.map((addon) => addon.value);
      e = { ...e, addons: finalAddons };
    }

    if (currentState === "edit") {
      dispatch(updateOrder(currentData?._id, e));
    } else {
      dispatch(createOrder(e));
    }
    handleToggleBackdrop({}, "");
  };

  const handleAgreePasswordReset = (productAmount) => {
    console.log(
      "🚀 ~ file: index.js:103 ~ handleAgreePasswordReset ~ handleAgreePasswordReset:",
      productAmount
    );
    setDynamicProductAmount(productAmount);
    handleToggleBackdrop(
      {
        _id: "",
        requestedBy: "",
        assignedTo: "",
        product: "",
        service: "",
        supplier: "",
        addons: "",
        computedAmount: 0,
        adminNotes: "",
        status: "",
        responseRequirements: "",
        startDate: "",
        endDate: "",
      },
      ""
    );
  };

  return (
    <MDBox display="flex" alignItems="center" lineHeight={0}>
      <MDBox mt="auto">
        <MDProductPercentageDialog
          product={selectProduct}
          onAgree={(productAmount) => handleAgreePasswordReset(productAmount)}
          customButton={
            <MDButton
              component="a"
              href="#"
              rel="noreferrer"
              variant="gradient"
              color="info"
            >
              <Icon sx={{ fontWeight: "bold" }}>add</Icon>
              &nbsp;Create Order
            </MDButton>
          }
        />
        {/* <MDButton
          component="a"
          href="#"
          rel="noreferrer"
          variant="gradient"
          color="info"
          onClick={() =>
            handleToggleBackdrop(
              {
                _id: "",
                requestedBy: "",
                assignedTo: "",
                product: "",
                service: "",
                supplier: "",
                addons: "",
                computedAmount: 0,
                adminNotes: "",
                status: "",
                responseRequirements: "",
                startDate: "",
                endDate: "",
              },
              ""
            )
          }
        >
          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
          &nbsp;Create Order
        </MDButton> */}
      </MDBox>

      <MDActionConfigurator
        ref={configuratorRef}
        title="Order Config"
        subtitle={`Order for ${selectProduct?.service?.service} product: ${selectProduct?.productName} - ${selectProduct?.productNumber} under supplier: ${selectProduct?.supplier?.supplierName}`}
        productAmount={dynamicProductAmount}
        onCompleteConfig={handleSubmitOrder}
        data={[
          {
            keyType: "_id",
            valueType: currentData?._id,
          },
          {
            labelType: "Selected Product",
            placeholderType: "Selected Product",
            dataType: "disabled",
            keyType: "product",
            valueType: selectProduct?._id,
          },
          {
            labelType: "Requested By",
            placeholderType: "Select Client",
            dataType: "select",
            keyType: "requestedBy",
            valueType: currentData?.requestedBy,
            options: selectClient,
          },
          {
            labelType: "Assingned To",
            placeholderType: "Select Admin User",
            dataType: "select",
            keyType: "assignedTo",
            valueType: currentData?.assignedTo,
            options: selectAdminUser,
          },
          {
            labelType: "Addons",
            placeholderType: "Select Addons",
            dataType: "dropdowncheckbox",
            keyType: "addons",
            valueType: currentData?.addons ? currentData?.addons : [],
            options: selectAddons,
          },
          {
            labelType: "Start Date",
            placeholderType: "Enter Start Date",
            dataType: "date",
            keyType: "startDate",
            valueType: currentData?.startDate,
          },
          {
            labelType: "End Date",
            placeholderType: "Enter End Date",
            dataType: "date",
            keyType: "endDate",
            valueType: currentData?.endDate,
          },
          {
            labelType: "Requirements",
            placeholderType: "Select Requirements",
            dataType: "productrequirement",
            keyType: "responseRequirements",
            valueType: currentData?.responseRequirements
              ? currentData?.responseRequirements
              : [],
            options: selectProduct?.productRequirements
              ? selectProduct?.productRequirements
              : [],
          },
          {
            labelType: "Computed Amount",
            placeholderType: "",
            dataType: "computedAmount",
            keyType: "computedAmount",
            valueType: currentData?.computedAmount,
          },
        ]}
        state={currentState}
      />
    </MDBox>
  );
}

export default CreateOrderButton;
